<template>
    <div class="board-container">
        <div v-show="false" class="board-search">
            <div class="board-search__box">
                <input v-model="filter.searchValue" class="board-search__input" type="text" name="" value="">
                <button class="board-search__button" type="submit" name="button" @click="search"></button>
            </div>
            <div class="board-search__select">
                <select v-model="filter.type" class="board-search__selectbox" name="">
                    <option value="" disabled selected>문의항목을 선택해주세요.</option>
                    <option v-for="(type, index) in questionTypes" :key="index" :value="type">{{ type }}</option>
                </select>
            </div>
        </div>
        <table class="board-list">
    		<thead class="d-none d-lg-table-header">
                <tr>
                    <th style="width:8.5%;" class="board-list__txt">번호</th>
                    <th style="width:66%;" class="board-list__txt">문의사항</th>
                    <th style="width:17%;" class="board-list__txt">답변상태</th>
                    <th style="width:8.5%;" class="board-list__txt">작성일</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(question, index) in questions" :key="question._id">
                    <td align="center" class="board-list__txt board-list__txt--first">
                        {{ (page - 1) * limit + index + 1 }}
                    </td>
                    <td align="center" class="board-list__tit" @click="details(question)">
                        <div class="ellip">{{ question.subject }}</div>
                    </td>
                    <td align="center" class="board-list__txt">
                        <span v-if="question.reply">답변완료</span>
                        <span v-else>미답변</span>
                    </td>
                    <td align="center" class="board-list__txt">
                        {{ question.createdAt.toDate() }}
                    </td>
                </tr>
    		</tbody>
    	</table>

        <!-- <div role="table" class="board-table board-table--inquiry">
            <div role="rowgroup">
                <div role="row">
                    <div role="columnheader" class="num">번호</div>
                    <div role="columnheader" class="title">문의사항</div>
                    <div role="columnheader" class="cell">문의유형</div>
                    <div role="columnheader" class="cell">답변상태</div>
                    <div role="columnheader" class="cell">작성일</div>
                </div>
            </div>
            <div v-for="(question, index) in questions" :key="question._id" role="rowgroup">
                <div role="row">
                    <div role="cell" class="num">{{ (page - 1) * limit + index + 1 }}</div>
                    <div role="cell" class="title"><div class="title"><a role="link" @click="details(question)">{{ question.subject }}</a></div></div>
                    <div role="cell" class="cell type">{{ question.type }}</div>
                    <div role="cell" class="cell state">
                        <span v-if="question.reply">답변완료</span>
                        <span v-else>미답변</span>
                    </div>
                    <div role="cell" class="cell date"><span class="date">{{ question.createdAt.toDate() }}</span></div>
                </div>
            </div>
        </div> -->

        <pagination-component v-model="page" :count="pageCount" @input="search"></pagination-component>
        
        <div class="button-group justify-end">
            <!-- <v-btn large outlined rounded color="grey" elevation="0" href="" class="min-w-120px min-w-lg-200px"><span class="color-grey">리스트</span></v-btn> -->
            <v-btn large rounded color="primary" elevation="0" @click="write" class="min-w-800px min-w-lg-100px"><span>글쓰기</span></v-btn>
        </div>

        <!-- <div class="board-buttons">
            <div class="left">
                <a class="button button--border" href=""><span>리스트</span></a>
            </div>
            <div class="right">
                <a class="button button--primary" @click="write"><span>글쓰기</span></a>
            </div>
        </div> -->
    </div>
</template>

<script>
import api from "@/api";

import PaginationComponent from "@/components/client/control/pagination-component.vue";

export default {
	components: {
        PaginationComponent
	},
    data() {
        return {
            filter: {
                searchKey: 'subject',
                searchValue: '',
                type: ''
            },

            page: 1,
            pageCount: 0,
            limit: 20,

            questions: [],
            questionTypes: [
                "회원정보 문의",
                "주문/결제 문의",
                "상품 문의",
                "배송 문의",
                "교환/반품 문의",
                "이벤트/혜택 문의",
                "서비스 개선 의견",
                "기타문의"
            ]
        };
    },
	mounted() {
		this.init();
	},
	methods: {
		init() {
            this.search();
            this.$nextTick(() => {
                // 문의내역 - 답변 토글
                (function(){
                    let question = document.querySelectorAll('.board-table--inquiry [role="button"]'),
                    answer = document.querySelectorAll('.board-table--inquiry [role="rowgroup"].answer');

                    for(let i = 0; i < question.length; i++)
                    question[i].addEventListener('click', toggleInquiry);

                    function toggleInquiry(){
                        let idx = this.getAttribute('data-idx'),
                        toggle = document.querySelector('.board-table--inquiry [role="rowgroup"][data-idx-answer="'+idx+'"]');

                        if(toggle !== null){
                            if(toggle.getAttribute('data-answer') === 'opened'){
                                for(let i = 0; i < answer.length; i++)
                                answer[i].removeAttribute('data-answer');
                            } else {
                                for(let i = 0; i < answer.length; i++)
                                answer[i].removeAttribute('data-answer');
                                toggle.setAttribute('data-answer', 'opened');
                            }
                        }
                    }
                })();
            });
		},

        write(){
            this.$router.push(`${this.$route.path}/create`);
        },

        details(question){
            this.$router.push(`${this.$route.path}/${question._id}`)
        },


        async search(){
            var { summary, questions } = await api.v1.center.questions.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });

            this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
            this.questions = questions;
        },
	},
}
</script>
